export default __webpack_public_path__ + "static/media/franchise.b4262bfa.svg";